<template>
    <div v-show="isLoaded" class="mMaridajeRose-container" v-observe-visibility="startAnimate">
        <div class="brushRose-background">
            <h2 class="mSection-title" :class="{animate: animate}">Maridaje</h2>
            <p class="mSection-subtitle" :class="{animate: animate}">Disfruta de los platillos ideales para maridar con Strongbow Rosé Apple, abriendo los sentidos a vivir su máximo sabor.</p>
        </div>
        <div class="img-container">
            <img class="img-maridaje mobile" :src="maridaje" alt="Maridaje Rose">
            <img class="img-maridaje desktop" :src="maridajeDesktop" alt="Maridaje Rose">
            <div class="stick"></div>
            <div class="point"></div>
        </div>
        <div class="mfeature feature-botana" v-observe-visibility="startAnimate1">
            <div class="rose-box feature-botana" :class="{animate: animate1}"></div>
                <h3 class="feature-title" :class="{animate: animate1}">Con <br>Botana</h3>
                <ul class="list-feature">
                    <li>Con nueces ligeramente salados.</li>
                    <br>
                    <li>Con frutas secas.</li>
                    <br>
                    <li>Tapas y bocadillos fritos con vegetales.</li>
                </ul>
        </div>
        <div class="mfeature feature-quesos" v-observe-visibility="startAnimate2">
            <div class="rose-box feature-quesos" :class="{animate: animate2}"></div>
                <h3 class="feature-title" :class="{animate: animate2}">Con <br>quesos</h3>
                <ul class="list-feature">
                    <li>De textura cremosa y sabores suaves ya sea de leche de vaca o cabra.</li>
                </ul>
        </div>
        <div class="mfeature feature-calientes" v-observe-visibility="startAnimate3">
            <div class="rose-box feature-calientes" :class="{animate: animate3}"></div>
                <h3 class="feature-title" :class="{animate: animate3, onlySafari: isSafari}">Con platos calientes</h3>
                <ul class="list-feature">
                    <li>Salmón, cangrejo o pescado (cocido o crudo).</li>
                    <li>Con pechuga de pollo o pato.</li>
                    <li>Callo de hacha salteado en salsa.</li>
                    <li>Pastas con salsas cremosas o con base de mantequilla, hierbas, vegetales y proteínas.</li>
                </ul>
        </div>
        <div class="mfeature feature-frios" v-observe-visibility="startAnimate4">
            <div class="rose-box feature-frios" :class="{animate: animate4}"></div>
                <h3 class="feature-title" :class="{animate: animate4}">Con platos <br>frios</h3>
                <ul class="list-feature">
                    <li>Carne fría como jamón de Parma, salchichas y mortadelas.</li>
                    <br>
                    <li>Entremeses de pescados frescos.</li>
                    <br>
                    <li>Langostinos, ensaladas frías cremosas.</li>
                </ul>
        </div>
        <div class="mfeature feature-postres" v-observe-visibility="startAnimate5">
            <div class="rose-box feature-postres" :class="{animate: animate5}"></div>
                <h3 class="feature-title" :class="{animate: animate5}">Con <br>postres</h3>
                <ul class="list-feature">
                    <li>Tarta de pera, almendra y miel.</li>
                    <br>
                    <li>A base de miel y frutos secos (dedos de reina o pasteles con estos ingredientes).</li>
                    <br>
                    <li>Crepas de almendras, nuez y miel.</li>
                </ul>
        </div>
    </div>
</template>

<script>
import maridajeDesktop from "@/assets/rose-apple/maridaje_rose.png"
import maridaje from "@/assets/rose-apple/maridaje_rose.jpg"
import Bowser from "bowser"; 
import { mapGetters } from "vuex";
export default {
    name: "MaridajeRose",
    components: {},
    data() {
        return {
            maridajeDesktop,
            maridaje,
            animate: false,
            animate1: false,
            animate2: false,
            animate3: false,
            animate4: false,
            animate5: false,
            isSafari: false
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true
            }
        },
        startAnimate1(isVisible) {
            if(isVisible) {
                this.animate1=true
            }
        },
        startAnimate2(isVisible) {
            if(isVisible) {
                this.animate2=true
            }
        },
        startAnimate3(isVisible) {
            if(isVisible) {
                this.animate3=true
            }
        },
        startAnimate4(isVisible) {
            if(isVisible) {
                this.animate4=true
            }  
        },
        startAnimate5(isVisible) {
            if(isVisible) {
                this.animate5=true
            }  
        },
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/RoseApple/MaridajeRose.scss";
</style>